import { AxiosResponse } from "axios";
import MiMPrivateService from "./MiMPrivateService";
import { IServiceResponse } from "../interfaces/General/IServiceResponse";
import { ILicenceType } from "interfaces/Licence/ILicenceType";

class LicenceService extends MiMPrivateService {
  getLicenceTypes(): Promise<AxiosResponse<IServiceResponse<ILicenceType[]>>> {
    return this.http.get("v1/licences");
  }
}

export default LicenceService;
